export const mockData = {
  hero: {
    title: "Fondi Interprofessionali: Formazione Aziendale Finanziata al 100%",
    subtitle: "Gestiamo completamente l'accesso ai fondi interprofessionali per la tua azienda: adesione, piano formativo e rendicontazione",
    cta: "Richiedi Consulenza Gratuita"
  },

  stats: [
    { number: "500+", label: "Aziende Servite" },
    { number: "10000+", label: "Ore di Formazione Erogate" }, // 👈 tolto il punto per evitare problemi JS
    { number: "100%", label: "Finanziamento Coperto" },
    { number: "15+", label: "Anni di Esperienza" }
  ],

  howItWorks: [
    {
      step: "01",
      title: "Analisi Iniziale",
      description: "Analizziamo le opportunità disponibili per la tua azienda e identifichiamo il fondo interprofessionale più adatto alle tue esigenze."
    },
    {
      step: "02",
      title: "Analisi Fabbisogni",
      description: "Individuiamo le reali esigenze formative della tua azienda, anche quelle non esplicite, per massimizzare il valore del progetto."
    },
    {
      step: "03",
      title: "Progettazione Piano",
      description: "Costruiamo il piano formativo completo, conforme ai requisiti dei fondi e ottimizzato per le tue necessità aziendali."
    },
    {
      step: "04",
      title: "Coordinamento Completo",
      description: "Gestiamo tutto il processo coordinando azienda, ente di formazione e docenti, senza alcun impatto organizzativo per te."
    },
    {
      step: "05",
      title: "Erogazione Formazione",
      description: "Organizziamo e supervisioniamo le attività formative garantendo qualità ed efficacia didattica."
    },
    {
      step: "06",
      title: "Gestione Amministrativa",
      description: "Prepariamo tutta la documentazione necessaria per evitare problemi in fase di controllo e ispezione."
    }
  ],

  services: [
    {
      title: "Consulenza Fondi Interprofessionali",
      description: "Analisi delle opportunità disponibili e scelta del fondo più adatto alla tua realtà aziendale.",
      icon: "briefcase"
    },
    {
      title: "Analisi Fabbisogni Formativi",
      description: "Individuazione delle reali esigenze aziendali, anche quelle non esplicite, per una formazione mirata.",
      icon: "search"
    },
    {
      title: "Progettazione Piani Formativi",
      description: "Costruzione completa del progetto formativo conforme ai requisiti dei fondi interprofessionali.",
      icon: "file-text"
    },
    {
      title: "Gestione Completa del Processo",
      description: "Coordinamento tra azienda, ente di formazione e docenti per un'esperienza senza stress.",
      icon: "users"
    },
    {
      title: "Erogazione e Coordinamento Didattico",
      description: "Organizzazione delle attività formative e supervisione per garantire qualità ed efficacia.",
      icon: "graduation-cap"
    },
    {
      title: "Supporto Amministrativo",
      description: "Preparazione documentazione completa per evitare problemi in fase di controllo/ispezione.",
      icon: "shield-check"
    }
  ],

  whyChooseUs: [
    {
      title: "Zero Impatto Economico",
      description: "La formazione è completamente finanziata dai fondi interprofessionali. Nessun costo diretto per la tua azienda."
    },
    {
      title: "Gestione Chiavi in Mano",
      description: "Ci occupiamo di tutto il processo dall'analisi alla rendicontazione. Tu ti concentri sul tuo business."
    },
    {
      title: "Esperienza Nazionale",
      description: "Migliaia di ore di formazione erogate e centinaia di aziende servite in tutta Italia."
    },
    {
      title: "Rete Consolidata",
      description: "Collaborazioni con enti di formazione accreditati e una rete di docenti qualificati."
    },
    {
      title: "Conformità Garantita",
      description: "Massima attenzione alla documentazione per evitare problemi in fase ispettiva."
    },
    {
      title: "Approccio Personalizzato",
      description: "Ogni progetto è costruito sulle reali esigenze della tua azienda, non su modelli standard."
    }
  ],

  caseStudies: [
    {
      company: "Azienda Manifatturiera - Lombardia",
      sector: "Settore Metalmeccanico",
      challenge: "Necessità di aggiornamento competenze digitali per 25 dipendenti",
      solution: "Piano formativo su Industria 4.0 e digitalizzazione processi produttivi",
      results: [
        "€45.000 di formazione finanziata",
        "150 ore di formazione erogate",
        "100% di partecipazione dei dipendenti",
        "Zero impatto sui costi aziendali"
      ]
    },
    {
      company: "Struttura Ricettiva - Reggio Calabria",
      sector: "Turismo e Hospitality",
      challenge: "Necessità di formare lo staff su accoglienza turistica, lingue straniere e marketing digitale",
      solution: "Piano formativo su hospitality management, inglese professionale e social media marketing turistico",
      results: [
        "€35.000 di finanziamento ottenuto",
        "120 ore di formazione specialistica",
        "18 operatori turistici formati",
        "Nessun costo per la struttura"
      ]
    }
  ],

  faqs: [
    {
      question: "Cosa sono i fondi interprofessionali?",
      answer: "I fondi interprofessionali sono organismi paritetici che finanziano la formazione continua dei lavoratori dipendenti. Le aziende vi aderiscono volontariamente destinando lo 0,30% dei contributi INPS al fondo scelto."
    },
    {
      question: "Come funzionano i fondi interprofessionali?",
      answer: "I fondi raccolgono lo 0,30% dei contributi INPS e li mettono a disposizione delle aziende aderenti per finanziare piani formativi tramite Conto Formazione o Avvisi pubblici."
    },
    {
      question: "L'adesione ai fondi interprofessionali è gratuita?",
      answer: "Sì, l'adesione è completamente gratuita. Le risorse provengono dallo 0,30% già versato all'INPS: l'azienda non paga nulla in più."
    },
    {
      question: "Qual è la differenza tra Conto Formazione e Avviso?",
      answer: "Il Conto Formazione è individuale per ogni azienda. L'Avviso è collettivo tramite bandi periodici, ideale per le PMI con quote ridotte."
    },
    {
      question: "Quale fondo interprofessionale conviene scegliere?",
      answer: "Dipende dal settore, CCNL, dimensione aziendale e tipo di formazione. MB Consulting ti guida nella scelta del fondo più adatto."
    },
    {
      question: "MB Consulting gestisce tutto il processo?",
      answer: "Sì. Dalla scelta del fondo alla progettazione del piano formativo fino alla rendicontazione finale: gestiamo tutto noi."
    },
    {
      question: "In quanto tempo si ottiene la formazione finanziata?",
      answer: "In media 2-6 mesi dalla scelta del fondo all'avvio della formazione, a seconda del fondo e della modalità di accesso."
    }
  ],

  contact: {
    email: "mariobruzzese@hotmail.com",
    phone: "+393291747521",
    address: "Reggio Calabria, Italia"
  }
};